import React, { useRef } from "react";

const Test = () => {
  const loaderRef = useRef();

  const handleLoad = () => {
    if (loaderRef.current) {
      loaderRef.current.style.display = "none";
      loaderRef.current.style.visibility = "hidden";
      loaderRef.current.remove();
    }
  };
  return (
    <div style={{ height: "100vh" }}>
      <iframe
        loading="lazy"
        src={
          "https://uat.mmihomedelivery.ae/?uuid=123e4567-e89b-12d3-a456-426614174000"
        }
        width="100%"
        height="100%"
        title="Payment Preview"
        scrolling="no"
        onLoad={handleLoad}
        allow="payment"
      ></iframe>
    </div>
  );
};

export default Test;
